import { createSlice } from '@reduxjs/toolkit'
import { cloneDeep, defaultsDeep, merge } from 'lodash'
import { resetProduct } from '../../app/actions'
import { novaApi } from '../../services/novaApi'
import { logout } from '../auth/authSlice'

export const extendedApiSlice = novaApi.injectEndpoints({
	overrideExisting: true,
	endpoints: builder => ({
		getClifeIllustration: builder.mutation({
			async queryFn(arg, api, extraOptions, baseQuery) {
				const { auth, clife } = api.getState()
				const agent = auth.agent
				const is_fass_user = auth.isFassUser
				const current_agent = auth.currentAgent
				const qid = clife?.quote?.qid || ''
				try {
					const response = await baseQuery(
						{
							url: 'clife',
							method: 'POST',
							body: { ...arg, qid, agent, current_agent, is_fass_user },
						},
						api,
						extraOptions,
					)
					return response
				} catch (error) {
					return error
				}
			},
		}),
	}),
})

export const { useGetClifeIllustrationMutation } = extendedApiSlice

const initialState = {
	plan: {
		sum_assured: '',
	},
	benefits: {
		lt: {
			sum_assured: '',
			term: '',
			type: '',
		},
		rr: {
			applicant_age: '',
			additional_premium: '',
		},
	},
	ratings: {
		cl: [
			{
				occrate: '0.00',
				medrate: '0.00',
				avorate: '0.00',
			},
			{
				occrate: '0.00',
				medrate: '0.00',
				avorate: '0.00',
			},
		],
		lt: {
			occrate: '0.00',
			medrate: '0.00',
			avorate: '0.00',
		},
	},
	quote: null,
	is_saved: false,
}

const clifeSlice = createSlice({
	name: 'clife',
	initialState,
	reducers: {
		clifePlanUpdated: (state, action) => {
			const newState = cloneDeep(defaultsDeep(action.payload, initialState))

			// prevents resetting quote when illustration is in an error state
			if (!!!newState.quote && !!state.quote) {
				newState.quote = { ...state.quote }
			}

			return merge(state, newState)
		},
		clifeQuoteUpdated: (state, action) => {
			return merge(state, action.payload)
		},
	},
	extraReducers: builder => {
		builder
			.addCase(resetProduct, () => {
				return initialState
			})
			.addCase(logout, state => initialState)
	},
})

export const { clifePlanUpdated, clifeQuoteUpdated } = clifeSlice.actions
export const selectClife = state => state.clife

export default clifeSlice.reducer
